import { FormValidationRule } from "../../forms/types";
import isValidDate from "./isValidDate";
import maxAge from "./maxAge";
import minAge from "./minAge";
import maxDateRangeRule from "./maxDateRangeRule";
import minDateRangeRule from "./minDateRangeRule";
import isWeekend from "./isWeekend";
import isSunday from "./isSunday";
import isPastOrToday from "./isPastOrToday";
import isFutureOrToday from "./isFutureOrToday";
import maxDateRule from "./maxDateRule";
import minDateRule from "./minDateRule";
import minDate from "./minDate";
import maxDate from "./maxDate";
import isExcluded from "./isExcluded";
import isStartBeforeEnd from "./isStartBeforeEnd";

const dateRules: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if ((c.type === "date" || c.type === "date_v2") && v) {
        const value = (c.inputs) ? v[c.inputs[0].id] : v;
        [valid, message] = isValidDate(c, value);
        if (valid) [valid, message] = isPastOrToday(c, value);
        if (valid) [valid, message] = isFutureOrToday(c, value);
        if (valid) [valid, message] = isWeekend(c, value);
        if (valid) [valid, message] = isSunday(c, value);
        if (valid) [valid, message] = isExcluded(c, value);
        if (valid) [valid, message] = minAge(c, value);
        if (valid) [valid, message] = maxAge(c, value);
        if (valid) [valid, message] = minDate(c, value);
        if (valid) [valid, message] = maxDate(c, value);
        if (valid) [valid, message] = minDateRule(c, value);
        if (valid) [valid, message] = maxDateRule(c, value);
        if (valid) [valid, message] = minDateRangeRule(c, value);
        if (valid) [valid, message] = maxDateRangeRule(c, value);

        message = c.errorMessage || message;
    }

    if (c.type === "boi_date_range" && c.inputs && v) {
        const startDate = v[c.inputs[0].id];
        const endDate = v[c.inputs[1].id];

        [valid, message] = isValidDate(c, startDate);
        if (valid) [valid, message] = isValidDate(c, endDate);
        if (valid) [valid, message] = isStartBeforeEnd(c, v);
        if (valid) [valid, message] = isPastOrToday(c, startDate);
        if (valid) [valid, message] = isPastOrToday(c, endDate);
        if (valid) [valid, message] = isFutureOrToday(c, startDate);
        if (valid) [valid, message] = isFutureOrToday(c, endDate);
        if (valid) [valid, message] = isWeekend(c, startDate);
        if (valid) [valid, message] = isWeekend(c, endDate);
        if (valid) [valid, message] = isExcluded(c, startDate);
        if (valid) [valid, message] = isExcluded(c, endDate);
        if (valid) [valid, message] = minDateRule(c, startDate);
        if (valid) [valid, message] = minDateRule(c, endDate);
        if (valid) [valid, message] = maxDateRule(c, startDate);
        if (valid) [valid, message] = maxDateRule(c, endDate);
        if (valid) [valid, message] = minDateRangeRule(c, v);
        if (valid) [valid, message] = maxDateRangeRule(c, v);

        message = c.errorMessage || message;
    }
    return [valid, message];
};

export default dateRules;
